import React,{useEffect,useRef,useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {FiMessageCircle,FiCalendar,FiSend,FiGrid,FiPlus} from 'react-icons/fi';

export default function FloatingActions(){
  const [open,setOpen]=useState(false);
  const menuRef=useRef(null);
  const {t}=useTranslation();
  const items=[['contact','/contact',FiMessageCircle],['consultation','/consultation',FiCalendar],['proposal','/proposal',FiSend],['demo','/products',FiGrid]];
  useEffect(()=>{
    const closeMenu=event=>{if(menuRef.current&&!menuRef.current.contains(event.target))setOpen(false)};
    const closeOnEscape=event=>{if(event.key==='Escape')setOpen(false)};
    document.addEventListener('pointerdown',closeMenu);
    document.addEventListener('keydown',closeOnEscape);
    return()=>{document.removeEventListener('pointerdown',closeMenu);document.removeEventListener('keydown',closeOnEscape)};
  },[]);
  return <aside ref={menuRef} className={`floating-actions${open?' open':''}`} aria-label="Quick actions">
    <button className="floating-trigger" type="button" aria-expanded={open} aria-controls="floating-action-menu" aria-label={open?'Close quick actions':'Open quick actions'} onClick={()=>setOpen(value=>!value)}><FiPlus aria-hidden="true"/></button>
    <div className="floating-links" id="floating-action-menu" aria-hidden={!open}>{items.map(([label,path,Icon])=><Link key={path} to={path} tabIndex={open?0:-1} aria-label={t(label)} title={t(label)} onClick={()=>setOpen(false)}><Icon aria-hidden="true"/><span>{t(label)}</span></Link>)}</div>
  </aside>;
}
